import { connect } from 'react-redux';

import { actions as pinsActions } from 'modules/pins';

import SearchBox from '../components/SearchBox';

const { setNewPin } = pinsActions;

export default connect(null, dispatch => ({
    onSearch: place => {
        const {
            geometry: { location },
        } = place;
        const payload = {
            lat: location.lat(),
            lng: location.lng(),
            searched: true,
        };
        dispatch(setNewPin(payload));
    },
}))(SearchBox);
